import { DehydratedState, QueryClient } from '@tanstack/react-query';

import { IApplicationContext } from '../../../shared/types/customContextParams';
import { IServerSideState } from '../../../shared/types/serverSideState';
import { ServerSideState } from '../../../shared/utils/serverSideState';

export class BrowserServerSideState extends ServerSideState implements IServerSideState {
  public static getInstance(context: IApplicationContext): IServerSideState {
    const { config } = context;

    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnMount: false,
          refetchOnWindowFocus: false,
        },
      },
    });

    const dehydratedState = config.getStrict<DehydratedState>('serverSideState');

    return new BrowserServerSideState(queryClient, dehydratedState);
  }

  private constructor(queryClient: QueryClient, dehydratedState: DehydratedState) {
    super(queryClient, dehydratedState);
  }
}
